<template>
  <div class="row">
    <div class="col-md-6">
      <card-box>
        <button class="float-right btn btn-light btn-sm" @click="modeAdd">
          <i class="fi-plus" />
        </button>
        <card-title>{{ editMode == true ? 'Edit Menu': 'Create Menu' }}</card-title>

        <div class="form-group">
          <label for="name">Name</label>
          <input id="name" v-model="name" type="name" class="form-control" placeholder="Menu name">
        </div>

        <div v-if="type == 'link'" class="form-group">
          <label for="url">Url</label>
          <input id="url" v-model="link" type="url" class="form-control" placeholder="http://">
        </div>
        <button v-if="editMode == false" type="submit" class="btn btn-primary" @click="create">
          Create
        </button>
        <button v-if="editMode == true" type="submit" class="btn btn-primary" @click="update">
          Save
        </button>
      </card-box>
    </div>
    <div class="col-md-6">
      <card-box>
        <card-title>Menu Item</card-title>
        <p>Drag and drop to sort menu</p>
        <draggable v-model="menus" :element="'ul'" class="list-group mt-3" :options="{group:'menu'}"
                   @start="drag=true" @end="endDrag">
          <transition-group type="transition" :name="'flip-list'">
            <li v-for="item in menus" :key="item.id" class="list-group-item" @click="edit(item)">
              <i class="fi-trash float-right" @click="remove(item)" />
              <span @click="modeEdit(item)"><i class="fi-menu mr-2" />
                                {{ item.name }}</span>
            </li>
          </transition-group>
        </draggable>
      </card-box>
    </div>
  </div>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";
    import draggable from 'vuedraggable'

    export default {
        name: "MenuStore",
        components: {CardBox, CardTitle, draggable},
        data: function () {
            return {
                name: '',
                link: '',
                type: 'link',
                editMode: false,
                items: [],
                menus: [],
                lock: false,
                id: ''
            }
        },

        watch: {
            type: function (val) {
                if (val == 'collection') {
                    this.collection()
                }
            }
        },
        mounted: function () {


            this.list()
        },

        methods: {
            endDrag:function() {
                this.$http.post(this.$config.api + 'menu/order', this.menus).then(function () {
                    //vm.list()
                })
            },
            modeAdd: function () {
                this.editMode = false
                this.name = ''
                this.link = ''
            },
            modeEdit: function (item) {
                let vm = this
                vm.editMode = true
                vm.name = item.name
                vm.link = item.link
                vm.id = item.id
            },

            update: function () {
                let post = {
                    name: this.name,
                    type: this.type,
                    link: this.link,
                    id: this.id
                }
                let vm = this

                if (this.name == '') {
                    this.$swal('Please enter menu name')
                    return false
                }

                this.$http.post(this.$config.api + 'menu', post).then(function () {
                    //  if (res.data == true)
                    vm.name = ''
                    vm.link = ''
                    vm.id = ''
                    vm.list()
                })
            },

            list: function () {
                let vm = this
                this.$http.get(this.$config.api + 'menu').then(function (res) {
                    let tmp = res.data.results
                    vm.menus = tmp
                })
            },
            create: function () {
                let post = {
                    name: this.name,
                    type: this.type,
                    link: this.link
                }
                let vm = this

                if (this.name == '') {
                    this.$swal('Please enter menu name')
                    return false
                }

                this.$http.put(this.$config.api + 'menu', post).then(function () {
                    //  if (res.data == true)
                    vm.name = ''
                    vm.link = ''
                    vm.list()
                })
            },

            remove: function (item) {
                let vm = this

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can not revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete(this.$config.api + 'menu/' + item.id).then(function () {
                            vm.list()
                        })
                        this.$swal('Deleted', 'You successfully deleted this menu', 'success')
                    } else {
                        this.$swal('Cancelled', 'Your menu is still intact', 'info')
                    }
                })


            }
        }
    }
</script>

<style lang="scss" scoped>
    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        cursor: move;
    }

    .list-group-item i {
        cursor: pointer;
    }

    table {
        border: none !important;
        td {
            border: none !important;
        }
    }
</style>